export type UploadAssetType = 'logo' | 'map-marker' | 'ar-asset' | 'background'

type UploadConstraint = {
  allowedExtensions: string[]
  maxBytes: number
}

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp']
const IMAGE_MAX_BYTES = 5 * 1024 * 1024
const MODEL_EXTENSIONS = ['.glb']
const MODEL_MAX_BYTES = 50 * 1024 * 1024

const uploadConstraints: Record<UploadAssetType, UploadConstraint> = {
  logo: {
    allowedExtensions: IMAGE_EXTENSIONS,
    maxBytes: IMAGE_MAX_BYTES,
  },
  'map-marker': {
    allowedExtensions: IMAGE_EXTENSIONS,
    maxBytes: IMAGE_MAX_BYTES,
  },
  background: {
    allowedExtensions: IMAGE_EXTENSIONS,
    maxBytes: IMAGE_MAX_BYTES,
  },
  'ar-asset': {
    allowedExtensions: MODEL_EXTENSIONS,
    maxBytes: MODEL_MAX_BYTES,
  },
}

const formatMaxSize = (bytes: number): string => {
  const megabytes = bytes / (1024 * 1024)
  return `${Number.isInteger(megabytes) ? megabytes : megabytes.toFixed(1)}MB`
}

export const getAcceptedUploadTypes = (fileType: UploadAssetType): string =>
  uploadConstraints[fileType].allowedExtensions.join(',')

export const getAssetValidationError = (
  file: Pick<File, 'name' | 'size'>,
  fileType: UploadAssetType,
): string | null => {
  const constraints = uploadConstraints[fileType]
  const extension = `.${file.name.split('.').pop()?.toLowerCase() ?? ''}`

  if (!constraints.allowedExtensions.includes(extension)) {
    return `File type not allowed. Accepted types: ${constraints.allowedExtensions.join(', ')}`
  }

  if (file.size > constraints.maxBytes) {
    return `File size exceeds the maximum limit of ${formatMaxSize(constraints.maxBytes)}`
  }

  return null
}
